import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';

import { rem } from 'design-system';
import Text from 'design-system/Text';

import BroadbandFilterBox from './BroadbandFilterBox';
import RadioForm from './RadioForm';

// const phone_props = [
//   { label: <Text Text-16>Cheapest by provider</Text>, value: 0 },
//   { label: <Text Text-16>Everything</Text>, value: 1 },
//   { label: <Text Text-16>Inclusive eve and w/e calls</Text>, value: 2 },
//   { label: <Text Text-16>Inclusive anytime calls</Text>, value: 3 },
//   { label: <Text Text-16>No inclusive calls</Text>, value: 4 },
//   { label: <Text Text-16>Deals without a phone line</Text>, value: 5 },
// ];

const speed_props = [
  {
    label: (
      <Text Numbers-16>
        10{' '}
        <Text TextThin-14 Secondary>
          MB
        </Text>
      </Text>
    ),
    value: 0,
    realValue: 10000,
  },
  {
    label: (
      <Text Numbers-16>
        30{' '}
        <Text TextThin-14 Secondary>
          MB
        </Text>
      </Text>
    ),
    value: 1,
    realValue: 30000,
  },
  {
    label: (
      <Text Numbers-16>
        55{' '}
        <Text TextThin-14 Secondary>
          MB
        </Text>
      </Text>
    ),
    value: 2,
    realValue: 55000,
  },
  {
    label: (
      <Text Numbers-16>
        100{' '}
        <Text TextThin-14 Secondary>
          MB
        </Text>
      </Text>
    ),
    value: 3,
    realValue: 100000,
  },
];

class BroadbandFilters extends PureComponent {
  state = this.props.state;

  _onTvValueChange = (data) => {
    this.setState({ isTVincluded: data });
    this.props.onFiltering('tvDeals', data, {
      ...this.state,
      isTVincluded: data,
    });
  };

  _onHomePhoneValueChange = (data) => {
    this.setState({ homePhoneOnly: data });
    this.props.onFiltering('homePhoneOnly', data, {
      ...this.state,
      homePhoneOnly: data,
    });
  };

  _onSIMChange = (data) => {
    this.setState({ isMobileSim: data });
    this.props.onFiltering('hasSim', data, {
      ...this.state,
      isMobileSim: data,
    });
  };

  _onIsCostOfNewLine = (data) => {
    this.setState({ isCostOfNewLine: data });
    this.props.onFiltering('includeCostOfNeLine', data, {
      ...this.state,
      isCostOfNewLine: data,
    });
  };

  // _onStandardChange = (data) => {
  //   this.setState({ isBroadbandStandard: data });
  //   this.props.onFiltering('standardBroadband', data, {
  //     ...this.state,
  //     isBroadbandStandard: data,
  //   });
  // };

  // _onFibreChange = (data) => {
  //   this.setState({ isBroadbandFibre: data });
  //   this.props.onFiltering('fibreBroadband', data, {
  //     ...this.state,
  //     isBroadbandFibre: data,
  //   });
  // };

  // _onLimitedChange = (data) => {
  //   this.setState({ isMonthlyUsageUnlimited: data });
  //   this.props.onFiltering('limitedBroadband', data, {
  //     ...this.state,
  //     isMonthlyUsageLimited: data,
  //   });
  // };

  // _onUnlimitedChange = (data) => {
  //   this.setState({ isMonthlyUsageUnlimited: data });
  //   this.props.onFiltering('unlimitedBroadband', data, {
  //     ...this.state,
  //     isMonthlyUsageUnlimited: data,
  //   });
  // };

  // _onChangePhoneCalls = (data) => {
  //   this.setState({ phoneCallsOptions: data });
  //   this.props.onFiltering('phoneCallOptions', data, {
  //     ...this.state,
  //     phoneCallsOptions: data,
  //   });
  // };

  _onChangeSpeed = (data) => {
    this.setState({ speedOptions: data });
    this.props.onFiltering('minimumSpeed', speed_props[data].realValue, {
      ...this.state,
      speedOptions: data,
    });
  };

  _onContract = (toggle, length) => {
    const { contractLength } = this.state;
    if (!toggle) {
      const index = contractLength.indexOf(length);
      if (index > -1) {
        const array = [...this.state.contractLength];
        array.splice(index, 1);

        const newState = {
          ...this.state,
          contractLength: array,
        };
        this.setState(newState, () => {
          this.props.onFiltering('contractLength', array, newState);
        });
      }
    } else {
      const newState = {
        ...this.state,
        contractLength: this.state.contractLength.concat([length]),
      };

      this.setState(newState, () => {
        this.props.onFiltering('contractLength', this.state.contractLength.concat([length]), newState);
      });
    }
  };

  _onContract1 = (data) => {
    this._onContract(data, 1);
  };

  _onContract12 = (data) => {
    this._onContract(data, 12);
  };

  _onContract18 = (data) => {
    this._onContract(data, 18);
  };

  _onContract24 = (data) => {
    this._onContract(data, 24);
  };

  _renderBroadbandOptions = () => (
    <>
      <View style={styles.sectionTitle}>
        <Text Text-16 Gray-70>
          Minimum speed
        </Text>
      </View>
      <RadioForm options={speed_props} initial={this.state.speedOptions} onPress={this._onChangeSpeed} />
    </>
  );

  _renderMobile = () => {
    const { isMobileSim } = this.state;
    return (
      <>
        <View style={styles.sectionTitle}>
          <Text Text-16 Gray-70>
            Mobile
          </Text>
        </View>
        <BroadbandFilterBox value={isMobileSim} onValueChange={this._onSIMChange} label="Show deals with mobile SIM" />
      </>
    );
  };

  _renderCosts = () => {
    const { isCostOfNewLine } = this.state;
    return (
      <>
        <View style={styles.sectionTitle}>
          <Text Text-16 Gray-70>
            Costs
          </Text>
        </View>
        <BroadbandFilterBox
          value={isCostOfNewLine}
          onValueChange={this._onIsCostOfNewLine}
          label="Include cost of new line"
        />
      </>
    );
  };

  _renderTvOptions = () => {
    const { isTVincluded } = this.state;
    return (
      <>
        <View style={styles.sectionTitle}>
          <Text Text-16 Gray-70>
            TV options
          </Text>
        </View>
        <BroadbandFilterBox value={isTVincluded} onValueChange={this._onTvValueChange} label="Include TV deals" />
      </>
    );
  };

  _renderOther = () => {
    const { homePhoneOnly } = this.state;
    return (
      <>
        <View style={styles.sectionTitle}>
          <Text Text-16 Gray-70>
            Other
          </Text>
        </View>
        <BroadbandFilterBox
          onValueChange={this._onHomePhoneValueChange}
          value={homePhoneOnly}
          label="Show homephone only"
        />
      </>
    );
  };

  // _renderPhoneCalls = () => {
  //   return null;
  //   return (
  //     <>
  //       <View style={styles.sectionTitle}>
  //         <Text Text-16 Gray-70>
  //           Phone calls / line options
  //         </Text>
  //       </View>
  //       <RadioForm
  //         options={phone_props}
  //         initial={this.state.phoneCallsOptions}
  //         onPress={this._onChangePhoneCalls}
  //       />
  //     </>
  //   );
  // };

  _renderContractLength = () => {
    const { contractLength } = this.state;
    return (
      <>
        <View style={styles.sectionTitle}>
          <Text Text-16 Gray-70>
            Contract length
          </Text>
        </View>
        <BroadbandFilterBox
          checkbox
          onValueChange={this._onContract1}
          value={contractLength.indexOf(1) > -1}
          label="1 month"
        />
        <BroadbandFilterBox
          checkbox
          onValueChange={this._onContract12}
          value={contractLength.indexOf(12) > -1}
          label="12 months"
        />
        <BroadbandFilterBox
          checkbox
          onValueChange={this._onContract18}
          value={contractLength.indexOf(18) > -1}
          label="18 months"
        />
        <BroadbandFilterBox
          checkbox
          onValueChange={this._onContract24}
          value={contractLength.indexOf(24) > -1}
          label="24 months"
        />
      </>
    );
  };

  render() {
    return (
      <View style={styles.container}>
        {this._renderBroadbandOptions()}
        {this._renderTvOptions()}
        {/* {this._renderPhoneCalls()} */}
        {this._renderContractLength()}
        {this._renderMobile()}
        {this._renderCosts()}
        {this._renderOther()}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    paddingBottom: rem(16),
  },
  sectionTitle: {
    paddingTop: rem(16),
    paddingBottom: rem(8),
    paddingHorizontal: rem(16),
  },
  filterBox: {
    flexDirection: 'row',
  },
});

export default BroadbandFilters;
